<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3" id="ch05"><a id="page_17"></a><span class="small">FIVE</span></h3>
<p class="noindenta">My family calls me George, sometimes Georgie, but my full name is Georgina Danforth Witley. I am familiar with pain, the kind of knowledge that comes with age.</p>
<p class="indent">Am I dead?</p>
<p class="indent">Harry?</p>
<p class="indent">Don’t answer. If you do, I’ll <em>know</em> I’m dead.</p>
<p class="indent">My left hand rests in soot. When I pat the earth, I come up with a piece of charred bark. Did someone build a fire on this very spot? My coat will be dirty.</p>
<p class="indent"><em>Soot is not a priority. Not here.</em></p>
<p class="indent">Who are you? The silent inquisitor?</p>
<p class="indent"><em>You’re practically home. Your two-storey house is up the hill, the driveway bare, the front door locked. It’s out of sight, but you know it’s there.</em></p>
<p class="indent">The door wants painting. It’s begun to chip. My ivies will need watering. I was on my way.</p>
<p class="indent"><em>The ivies are hardy. They’ll survive. The woods are the same that grow outside your back stoop; the treed hill descends.</em></p>
<p class="indent"><a id="page_18"></a>I’m in the ravine, then. I’m at the bottom of Spinney’s Ravine.</p>
<p class="indent">This is an outrage. I’ll miss my appointment with the Queen.</p>
<p class="indent">Surely not. I’ll get up. All I have to do is move.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch05.vue?49c1b4bf